import { POPUP, SAVE_TEMPLATE } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case SAVE_TEMPLATE.LOAD:
			return {
				...state,
				request: action.request,
				response: null,
				error: null,
			}
		case SAVE_TEMPLATE.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case SAVE_TEMPLATE.ERROR:
			return {
				...state,
				error: action.error,
			}
		case POPUP.CLOSE:
			return {
				...state,
				error: null,
			}
		case SAVE_TEMPLATE.CLEAR:
			return {
				...state,
				response: null,
				error: null,
			}
		default:
			return state
	}
}
